import React from 'react';
import fr from 'facet-rest';
import { pickComponentAndProps } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import InvestmentsRoot from './InvestmentsRoot';

const InvestmentsPicker = () => {
  const { userResource } = useUserContext();
  const { component: InvestmentsComponent, props: componentProps } = pickComponentAndProps(userResource, {
    [fr.relationships.investmentsPerformance.name]: [InvestmentsRoot, {}],
    [fr.relationships.default.name]: [() => null, {}],
  });

  return (
    <InvestmentsComponent {...componentProps} />
  );
};

export default InvestmentsPicker;
